import { Product } from '../interfaces/product.interface';
import { USER_PERMISSION, USER_STATUS } from '../app.constants';
import { UserInterface } from '../interfaces/userInterface';

export class User implements UserInterface{

    id?: string;
    firstName?: string;
    lastName: string;
    username?: string;
    companyName?: string;
    dynamicsCustomerId?: string;
    enterpriseCustomerId?: string;
    email: string;
    phoneNumber?: string;
    phoneExtension?: string;
    profileName?: string;
    profileId: string;
    products: string[];
    languageId?: string;
    language?: string;
    role?: string;
    createdAt?: string;
    lastLogin?: string;
    status?: USER_STATUS;
    isActive?: boolean;
    connectedProducts?: Product[];
    fullName?: string;
    initials?: string;
    userType?: string;
    permissions: USER_PERMISSION[] = [];
    unit4Employee?: boolean = false;
    user_id?: string;
    subscriptionLevel?: string;
    learningRole?: string;
    billingPlatformRole?: string;

    constructor(protected config?: any) {
        Object.assign(this, config);
        delete this.config;
        this.fullName = User.getFullName(this.firstName, this.lastName);
        this.initials = User.getInitials(this.firstName, this.lastName);
        // build the user type based in the permisions
        this.userType = this.getUserType();
    }

    static getFullName(firstName: string, lastName: string): string {
        let fullName = lastName;
        if (firstName) {
            fullName = `${fullName}, ${firstName}`;
        }
        return fullName;
    }

    static getInitials(firstName: string, lastName: string): string {
        let initials = '';
        if (lastName) {
            initials += lastName.substring(0, 1);
        }
        if (firstName) {
            initials = `${firstName.substring(0, 1)}${initials}`;
        }
        return initials.toUpperCase();
    }
    private getUserType() {
        let returnValue = '';
        if (this.unit4Employee === true) {
            returnValue = 'employee';
        } else if (this.permissions.includes('PARTNER')) {
            returnValue = 'partner';
        } else if (
            this.permissions.includes('SUPPORT_SERVICE_NOW') 
            || this.permissions.includes('NEWS') 
            || this.permissions.includes('SALES')
        ) {
            returnValue = 'customer';
        }
        return returnValue;
    }
}
